import { observer } from 'mobx-react-lite'
import { DrawerProps } from 'components/Drawer/Root'
import { Drawer } from 'components/Drawer'
import { Heading } from 'blaze-ui/Heading/Heading'
import { FunctionComponent } from 'react'
import { ChevronLeft } from 'blaze-ui/icons/24'

interface Props extends DrawerProps {
  component: FunctionComponent
}

export const InitializationDrawer = observer(({ component: Component, ...props }: Props) => (
  <Drawer.Root {...props}>
    <Drawer.Portal>
      <Drawer.Content>
        <Drawer.InnerContent>
          <Drawer.Top>
            <Drawer.Close icon={ChevronLeft} label="" />
            <Drawer.Title asChild>
              <Heading level={5}>Connect your account</Heading>
            </Drawer.Title>
          </Drawer.Top>
          <Drawer.Container>
            <Component />
          </Drawer.Container>
        </Drawer.InnerContent>
      </Drawer.Content>
      <Drawer.Overlay />
    </Drawer.Portal>
  </Drawer.Root>
))
